/**
 * Liga a telemetria mínima ao ciclo de vida da página (rodada 2B2).
 *
 * O que dispara o quê:
 *   - `document.visibilitychange` → segundo plano/retorno (abertura só depois
 *     de ≥ 30 min fora) e um envio antes de sumir;
 *   - `online` → envia o que ficou na fila sem rede;
 *   - `pagehide` → última chance de envio (o transporte usa `keepalive`).
 *
 * Os eventos em si vêm dos hooks (`useTelemetria.ts`): abertura no Shell e
 * área por rota. Sem identidade autenticada nada é gerado — e nada aqui
 * lança: telemetria nunca custa a ação da pessoa.
 */
import { CLIENT_RELEASE, estaStandalone } from '../observability/release';
import { lerViagemAtiva } from '../trip/viagemAtiva';
import { Telemetria, transporteHttp } from './telemetria';

let instancia: Telemetria | null = null;

export function telemetria(): Telemetria | null {
  return instancia;
}

export interface OpcoesDeTelemetria {
  usuarioAtual: () => string | null;
  janela?: Window & typeof globalThis;
}

export function instalarTelemetria(opts: OpcoesDeTelemetria): Telemetria {
  const w = opts.janela ?? window;
  const tele = new Telemetria({
    usuarioAtual: opts.usuarioAtual,
    transporte: transporteHttp,
    clientRelease: CLIENT_RELEASE,
    standalone: estaStandalone,
  });
  instancia = tele;

  const viagemAtiva = (): string | undefined => {
    try {
      const u = opts.usuarioAtual();
      return u ? (lerViagemAtiva(u)?.id ?? undefined) : undefined;
    } catch {
      return undefined;
    }
  };
  const seguro = (fn: () => unknown) => {
    try {
      void fn();
    } catch {
      /* nunca */
    }
  };

  w.document.addEventListener('visibilitychange', () => {
    seguro(() => {
      if (w.document.visibilityState === 'hidden') {
        tele.aoFicarOculto();
        void tele.enviarPendentes();
      } else {
        tele.aoFicarVisivel(viagemAtiva());
      }
    });
  });
  w.addEventListener('online', () => seguro(() => tele.enviarPendentes()));
  w.addEventListener('pagehide', () => seguro(() => tele.enviarPendentes()));
  // Na abertura, o que ficou de uma sessão anterior sem rede.
  w.setTimeout(() => seguro(() => tele.enviarPendentes()), 7000);
  return tele;
}
